export const budgetTransferAdditionalFields = [
  {
    name: "messages.reportCode",
    classNames: "mb-32 mt-16",
    label: "transfer.budgetTransfer.reportCode",
    placeholder: "transfer.budgetTransfer.enterReportCode",
  },
  {
    name: "messages.message1",
    classNames: "mb-32",
    label: "transfer.budgetTransfer.messageLineOne",
    placeholder: "transfer.budgetTransfer.enterMessageLineOne",
  },
  {
    name: "messages.message2",
    classNames: "mb-32",
    label: "transfer.budgetTransfer.messageLineTwo",
    placeholder: "transfer.budgetTransfer.enterMessageLineTwo",
  },
  {
    name: "messages.message3",
    classNames: "mb-32",
    label: "transfer.budgetTransfer.messageLineThree",
    placeholder: "transfer.budgetTransfer.enterMessageLineThree",
  },
  {
    name: "messages.message4",
    classNames: "mb-32",
    label: "transfer.budgetTransfer.messageLineFour",
    placeholder: "transfer.budgetTransfer.enterMessageLineFour",
  },
  {
    name: "messages.message5",
    classNames: "mb-32",
    label: "transfer.budgetTransfer.messageLineFive",
    placeholder: "transfer.budgetTransfer.enterMessageLineFive",
  },
  {
    name: "messages.message6",
    classNames: "mb-8",
    label: "transfer.budgetTransfer.messageLineSix",
    placeholder: "transfer.budgetTransfer.enterMessageLineSix",
  },
];
